import React, { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import StartupList from './components/startups/StartupList'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import StartupDetailsContainer from './components/startups/StartupDetailsContainer'
import theme from './theme'
import { CssBaseline, ThemeProvider } from '@mui/material'
import CommercialViabilityForm from './components/startups/CommercialViabilityForm'
import UploadStartup from './components/startups/edit/UploadStartup'
import { setToken, setProfile, setPermissions } from '../store/user/userSlice'
import { useAppSelector, useAppDispatch } from '../store/hooks'
import { getProfile, updateProfile, redeemInvitation } from '../networking/network'
import { UserProfile } from '../models/UserProfile'
import ProfileView from './components/user/ProfileView'
import AdminView from './components/admin/AdminView'
import Sidebar from './components/nav/Sidebar'
import UnauthenticatedView from './components/auth/UnauthenticatedView'
import UserScoresContainer from './components/user/UserScoresContainer'

function App () {
  const dispatch = useAppDispatch()
  const accessToken = useAppSelector(state => state.user.token)

  const {
    isAuthenticated,
    user,
    getAccessTokenSilently,
    loginWithRedirect,
    getIdTokenClaims
  } = useAuth0()

  useEffect(() => {
    if (!user) {
      return
    }
    const uploadProfile = async (token: string, profile: UserProfile) => {
      const fetchedProfile = await updateProfile(token, profile)
      fetchedProfile.logo_url = user.picture
      dispatch(setProfile(profile))
    }

    const loadUserProfile = async (token: string) => {
      const profile = await getProfile(token).catch((error) => {
        if (error.response && error.response.status === 404) {
          const profile: UserProfile = {
            user_id: user.sub!,
            email: user.email!
          }
          uploadProfile(token, profile)
        } else {
          throw error
        }
      })
      dispatch(setProfile(profile))
    }

    const claimInvitation = async (token: string, invitation: string) => {
      try {
        await redeemInvitation(token, invitation)
        loginWithRedirect()
      } catch (error) {
        console.error(error)
      }
      window.localStorage.removeItem('invitation')
    }

    const getToken = async () => {
      console.log(isAuthenticated)
      try {
        const fetchedToken = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE!
        })
        console.log(fetchedToken)

        const claims = await getIdTokenClaims()
        const permissions = claims?.authorization.permissions ?? []
        dispatch(setPermissions(permissions))

        dispatch(setToken(fetchedToken))
        loadUserProfile(fetchedToken)
        const invitation = window.localStorage.getItem('invitation')
        if (invitation !== null) {
          claimInvitation(fetchedToken, invitation)
        }
      } catch (e) {
        console.log(e)
      }
    }

    getToken()
  }, [isAuthenticated])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <Router>
        {accessToken !== null && 
          <div>
              <Sidebar />
              <div style={{
                marginLeft: '260px'
              }}>
                <Routes>
                  <Route path="/startups/:id/scores" element={
                    <UserScoresContainer />
                  } />

                  <Route path="/startups/:id/score" element={
                    <CommercialViabilityForm />
                  } />
                  <Route path="/startups/:id" element={
                    <StartupDetailsContainer />
                  } />
                  <Route path="/startups/add" element={
                    <UploadStartup />
                  } />
                  <Route path="/startups/:id/edit" element={
                    <UploadStartup />
                  } />
                  <Route path="/startups" element={
                    <StartupList />
                  } />
                  <Route path="/profile" element={
                    <ProfileView />
                  } />
                  <Route path="/" element={
                    <StartupList />
                  } />
                  
                  <Route path="/admin" element={
                    <AdminView />
                  } />
                </Routes>
              </div>        
          </div>
          } 
          {accessToken === null &&
            <UnauthenticatedView />
          }
        </Router>
      </CssBaseline>
    </ThemeProvider>
  )
}

export default App
